export const getIsElFocusedById = (id) => {
    const targetedEl = document.getElementById(id);
    return targetedEl ? targetedEl.contains(document.activeElement) : false;
};
export default getIsElFocusedById;
//# sourceMappingURL=index.js.map